import { Col } from 'antd';
import {
  StyledBackground,
  StyledCard,
  StyledRow,
} from 'features/auth/routes/login.styles';
import { UploadDocumentsItemLink } from 'features/document-report/components/upload-documents-link/documents-upload-link';
import { useUserContext } from 'features/users';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const UploadLinkDocuments = () => {
  const StorageToken = localStorage.getItem(
    'partnerplus_coustomer__access_token',
  );
  const params = useParams();
  const navigate = useNavigate();
  const { id, uniqueid } = params;
  const { companyUser } = useUserContext();
  const getAllCompanyIds = () => {
    // Check if `companyUser` and `rc` array exist
    if (companyUser?.rc?.length > 0) {
      // Map through the `rc` array to extract all `CompanyId` values
      return companyUser.rc.map((item: any) => item.CompanyId);
    }
    
return [];
  };
  const companyIds = getAllCompanyIds();
  useEffect(() => {
    if (!StorageToken) {
      navigate(`/login?returnUrl=uploaddocuments/${id}/${uniqueid}`);
    }
  }, [params, StorageToken, navigate]);

  return (
    <StyledBackground>
      <Col
        xs={24}
        sm={18}
        md={12}
        lg={12}
        xl={10}
        xxl={6}
        className='flex flex-col justify-center'
      >
        <Col xs={24} className='flex justify-center mb-10'>
          <img src='/partnerplus_logo.png' alt='login background' />
        </Col>
        <StyledCard>
          {companyIds.includes(id) && (
            <StyledRow justify='center'>
              <Col
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <label className='mt-0 mb-3 text-center text-2xl font-bold text-blue-950'>
                  Upload Documents
                </label>
                {/* <label className='mt-0 mb-5 text-center text-md font-medium tracking-tight text-gray-900'>Partner Plus Customer Portal</label> */}
              </Col>
            </StyledRow>
          )}
          <StyledRow justify='center'>
            <Col xs={24}>
              {/* <LoginForm /> */}
              <UploadDocumentsItemLink />
            </Col>
          </StyledRow>
        </StyledCard>
      </Col>
    </StyledBackground>
  );
};
